<div class="bl-wrapper">
  <h4 class="title">Share property with your buyers lists:</h4>

  <app-shared-loading
    *ngIf="loadingBuyersList"
    text="Loading buyers list..."
    position="left"
  ></app-shared-loading>

  <ng-container *ngIf="!loadingBuyersList">
    <div *ngIf="error">Unable to load buyers list. Please try again later.</div>

    <ng-container *ngIf="!error">
      <div *ngIf="all_buy_lists_one_day_limit">
        The free tier only allows you to share a buyers list once a day. Please
        upgrade to a paid tier to share a buyers list more than once a day.
      </div>

      <ng-container *ngIf="!all_buy_lists_one_day_limit">
        <div *ngIf="success" class="success">
          <ng-icon name="featherCheckCircle"></ng-icon>
          <span class="ml-1">
            Property shared successfully with the selected buyers list.
          </span>
        </div>

        <ng-container *ngIf="!success">
          <div class="items">
            <ng-container>
              <div
                *ngFor="let item of buyersList; trackBy: trackByFn"
                class="item"
              >
                <mat-checkbox
                  class="custom-checkbox"
                  color="primary"
                  [disabled]="
                    sending || item.allowShareParsed?.['allow_share?'] === false
                  "
                  [checked]="selected.has(item.id)"
                  (change)="toggleSelection(item.id, $event.checked)"
                >
                  {{ item.name }}
                  <sup *ngIf="item.allowShareParsed?.['allow_share?'] === false"
                    >Share available in {{ item.remainingTimeFormatted }}</sup
                  >
                </mat-checkbox>
              </div>
              <div *ngIf="!buyersList.length" class="no-data">
                No buyers list found. You can create one
                <a routerLink="/upload-buyers">here</a>.
              </div>
            </ng-container>
          </div>

          <div class="flex mt-2">
            <app-shared-button
              (click)="shareWithList()"
              [loading]="sending"
              [disabled]="selected.size === 0 || sending"
              [tp]="
                selected.size === 0
                  ? 'Select at least one buyers list.'
                  : undefined
              "
            >
              Share with list
            </app-shared-button>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
